"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var get_polling_delay_exports = {};
__export(get_polling_delay_exports, {
  getPollingDelay: () => getPollingDelay
});
module.exports = __toCommonJS(get_polling_delay_exports);
var import_ms = __toESM(require("ms"));
function getPollingDelay(elapsed) {
  if (elapsed <= (0, import_ms.default)("15s")) {
    return (0, import_ms.default)("1s");
  }
  if (elapsed <= (0, import_ms.default)("1m")) {
    return (0, import_ms.default)("5s");
  }
  if (elapsed <= (0, import_ms.default)("5m")) {
    return (0, import_ms.default)("15s");
  }
  return (0, import_ms.default)("30s");
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  getPollingDelay
});
